module.exports = __webpack_public_path__ + "img/UTGOBL-8.0817f953.jpg";